import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import DynamicBreadcrumbs from '../../../components/Shared/Breadcrumb/index.tsx';
import { ListPageHeader } from '../../../components/ui';
import { buildBreadcrumbs, createBreadcrumbNavigateHandler } from '../../../config/navigation/breadcrumbs';
import { ROUTES } from '../../../constants/routes';
import { ANALYTICS_COPY } from '../constants/analyticsCopy';

export default function AnalyticsPageHeader({ title, subtitle, action, sectionLabel }) {
  const navigate = useNavigate();
  const items = useMemo(() => {
    if (!sectionLabel) {
      return buildBreadcrumbs([{ label: ANALYTICS_COPY.moduleTitle }]);
    }
    return buildBreadcrumbs([
      { label: ANALYTICS_COPY.moduleTitle, href: ROUTES.FEATURES.ANALYTICS },
      { label: sectionLabel },
    ]);
  }, [sectionLabel]);

  return (
    <>
      <DynamicBreadcrumbs
        items={items}
        onBreadcrumbClick={createBreadcrumbNavigateHandler(navigate)}
      />
      <ListPageHeader title={title} subtitle={subtitle} action={action} sx={{ mb: 0 }} />
    </>
  );
}
